import styled from "styled-components";

export const StyledCardsContainer = styled.div`
    padding-top: 8px;
    padding-bottom: 68px;
    @media (min-width: 1920px) {
        padding-top: 16px;
        padding-bottom: 80px;
    }
`;

export const StyledCardWrapper = styled.div`
    &:not(:first-of-type) {
        margin-top: 32px;
    }
`;
